<!-- Footer has completed with equal gape -->
<footer id="footer">
    <div class="footer-top">
      <div class="container">
        <div class="row w-100 text-center">
          <div class="col-12 col-md-4">
            <div class=" footer-contact">
              <!-- <h3>Resi.</h3> -->
              <img
                src="../../../assets/img/doktorslogo.png"
                style="width:150px;z-index:999;"
              />
              <p>
                <!-- A108 Adam Street <br />
                New York, NY 535022<br />
                United States <br /><br /> -->
                <b>CITY CENTER MARKET NEAR NULIFE HOSPITAL
                  HARIDWAR ROAD NAJIBABAD,BIJNOR,
                  UTTARPRADESH,246763
                </b><br/>
                <strong>Phone:</strong> +91 80060 60805<br />
                <strong>Email:</strong> help@doqmatokens.com<br />
              </p>
            </div>
          </div>
          <div class="col-6 col-md-4">
            <div class="footer-links text-center">
              <h4>Useful Links</h4>
              <ul class="text-center">
                <!-- <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">Home</a>
                </li> -->
                <!-- <li>
                  <i class="bx bx-chevron-right"></i> <a href="#">About us</a>
                </li> -->
                <li class="text-center">
                  <i class="bx bx-chevron-right"></i>
                  <a href="termsconditoin"  target="_blank">Terms of service</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="privacypolicy" target="_blank">Privacy policy</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="refundpolicy" target="_blank">Refund policy</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="about" target="_blank">About Us</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="contact" target="_blank">Contact Us</a>
                </li>
                <li>
                  <i class="bx bx-chevron-right"></i>
                  <a href="pricing" target="_blank">Pricing</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-6 col-md-4"> 
          <div
          class=" footer-newsletter"
          style="text-align:center;" 
          id="nav;"
          
        >
          <h4>Download the app now</h4>
          <p>
            Get latest news on DOQMA on your mail and stay connected.
          </p>
          <!-- <form action="" method="post">
            <input type="email" name="email" /><input
              type="submit"
              value="Subscribe"
            />
          </form> -->
          <a class="me-lg-3 mb-4 mb-lg-0" href="https://play.google.com/store/apps/details?id=com.paspatient"
            ><img
              class="app-badge"
              src="assets/img/google-play-badge.svg"
              alt="..."
          /></a>
        </div>
          </div>

        </div>
      </div>
    </div>

    <div class="container pt-3 pb-3">
      <div class=" text-center ">
        <div class="copyright">
          &copy; Copyright <strong><span>Mavin Globus</span></strong
          >. All Rights Reserved
        </div>
      </div>
      <div class="social-links text-center text-md-right pt-3 pt-md-0">
        <!-- <a href="#" class="twitter"><i class="bi bi-twitter"></i></a> -->
        <!-- <a href="#" class="facebook"><i class="bi bi-facebook"></i></a> -->
        <!-- <a href="#" class="instagram"><i class="bi bi-instagram"></i></a> -->
        <!-- <a href="#" class="google-plus"><i class="bi bi-skype"></i></a> -->
        <!-- <a href="#" class="linkedin"><i class="bi bi-linkedin"></i></a> -->
      </div>
    </div>
  </footer>




  